import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const itemsSelector = (state: RootState) => state.article.items;
const readArticleIdsSelector = (state: RootState) =>
  state.article.readArticleIds;

export const unreadCountSelector = createSelector(
  itemsSelector,
  readArticleIdsSelector,
  (items, readArticleIds): number =>
    items.length - items.filter((a) => readArticleIds.includes(a.id)).length,
);
